import {TweenMax, Power2} from 'gsap';

export class BlockMarketing {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static openEl: number;

  public static init() {

    BlockMarketing.$element = $('.BlockMarketing');
    BlockMarketing.element = BlockMarketing.$element.get(0);

    BlockMarketing.openEl = 0;

    if (BlockMarketing.$element.length) {
      BlockMarketing.events();
    }
  }


  public static events() {
    BlockMarketing.$element.find(".BlockMarketing-step-background").on("click", function() {
      let elId = $(this).closest(".BlockMarketing-step").attr("id");
      let elNum = parseInt(elId.substr(elId.length - 1));

      if (BlockMarketing.openEl === 0) {
        BlockMarketing.open(elNum);
        BlockMarketing.openEl = elNum;
      } else if (BlockMarketing.openEl === elNum) {
        BlockMarketing.close(elNum);
        BlockMarketing.openEl = 0;
      } else {
        BlockMarketing.close(BlockMarketing.openEl);
        BlockMarketing.open(elNum);
        BlockMarketing.openEl = elNum;
      }

    });
  }

  public static close(item: number) {
    TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step1"), 0.5, {left: "0%"});
    TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step2"), 0.5, {left: "25%"});
    TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step3"), 0.5, {left: "50%"});
    TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step4"), 0.5, {left: "75%"});

    let elId = "#BlockMarketing-step" + item;
    let $element = BlockMarketing.$element.find(elId);

    $element.find(".BlockMarketing-step-toggle").text("+");
    TweenMax.to($element.find(".BlockMarketing-step-title"), 0.5, {"font-weight": "normal"});
    TweenMax.to($element.find(".BlockMarketing-step-separator"), 0.5, {"opacity": 0});
    TweenMax.to($element.find(".BlockMarketing-step-contentRight"), 0.5, {"opacity": 0});
  }

  public static open(item: number) {
    switch(item) {
      case 1:
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step4"), 0.5, {left: "125%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step3"), 0.5, {left: "100%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step2"), 0.5, {left: "75%"});
        break;
      case 2:
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step1"), 0.5, {left: "-25%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step2"), 0.5, {left: "0%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step4"), 0.5, {left: "100%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step3"), 0.5, {left: "75%"});
        break;
      case 3:
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step1"), 0.5, {left: "-50%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step2"), 0.5, {left: "-25%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step3"), 0.5, {left: "0%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step4"), 0.5, {left: "75%"});
        break;
      case 4:
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step1"), 0.5, {left: "-75%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step2"), 0.5, {left: "-50%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step3"), 0.5, {left: "-25%"});
        TweenMax.to(BlockMarketing.$element.find("#BlockMarketing-step4"), 0.5, {left: "0%"});
        break;
      default:
      // code block
    }

    let elId = "#BlockMarketing-step" + item;
    let $element = BlockMarketing.$element.find(elId);

    $element.find(".BlockMarketing-step-toggle").text("-");
    TweenMax.to($element.find(".BlockMarketing-step-title"), 0.5, {"font-weight": "bold"});
    TweenMax.to($element.find(".BlockMarketing-step-separator"), 0.5, {"opacity": 0.6});
    TweenMax.to($element.find(".BlockMarketing-step-contentRight"), 0.5, {"opacity": 1});
  }

}
